
































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import NumberTmpl from "@/ui-component/number.vue";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class LineTicketAudit extends mixins(MyMixin) {
  @Prop() public article!: any;
  @Prop({ default: false }) public showManager!: boolean;
  @Prop({ default: false }) public isAcc!: boolean;
  @Prop({ default: false }) public showUPrice!: boolean;

  public mounted() {
    // console.log(this.showUPrice, this.article);
  }
}
